var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBackgroundFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 886,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.742 885.408L.5 723.163l355.921-234.537v396.782H.741z",
    fill: "url(#paint0_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.742 885.408L.5 723.163l355.921-234.537v396.782H.741z",
    stroke: "#C62E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.419 885.408l-.966-397.206 240.192 54.772v342.434H357.419z",
    fill: "url(#paint1_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.419 885.408l-.966-397.206 240.192 54.772v342.434H357.419z",
    stroke: "#C62E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.646 885.408V542.873l175.739-95.334v437.869H597.646z",
    fill: "url(#paint2_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.646 885.408V542.873l175.739-95.334v437.869H597.646z",
    stroke: "#C62E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774.385 885.5V447.172l243.775-13.732V885.5H774.385z",
    fill: "url(#paint3_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M774.385 885.5V447.172l243.775-13.732V885.5H774.385z",
    stroke: "#C62E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.17 433.114l314.34-324.02v776.314h-314.34V433.114z",
    fill: "url(#paint4_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.17 433.114l314.34-324.02v776.314h-314.34V433.114z",
    stroke: "#C62E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334.51 885.408V108.242L1727.5.655v884.753h-392.99z",
    fill: "url(#paint5_linear_40_352)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.51 885.408V108.242L1727.5.655v884.753h-392.99z",
    stroke: "#C62E00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_352",
    x1: 25.858,
    y1: 758.819,
    x2: 133.402,
    y2: 415.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_352",
    x1: 373.425,
    y1: 758.78,
    x2: 517.366,
    y2: 448.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_352",
    x1: 609.95,
    y1: 745.735,
    x2: 805.149,
    y2: 465.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_352",
    x1: 791.619,
    y1: 741.397,
    x2: 967.174,
    y2: 403.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_352",
    x1: 1041.51,
    y1: 637.595,
    x2: 1386.44,
    y2: 139.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_352",
    x1: 1362.55,
    y1: 603.171,
    x2: 1741.26,
    y2: 2.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBackgroundFeature);
export default __webpack_public_path__ + "static/media/graph-background-feature.cd8397013089baec4670e8204fa67f82.svg";
export { ForwardRef as ReactComponent };